import { InitPageStrict } from "../../index";

class PickingHistory {
  constructor() {
    $("#PickingTable").on("click", ".picking-eos-push-view", (e) => {
      e.preventDefault();
      const link = e.currentTarget as HTMLElement;
      $("#picking-eos-push-headers").text(this.pretty(link.dataset.headers));
      $("#picking-eos-push-body").text(this.pretty(link.dataset.body));
      $("#picking-eos-push-response").text(this.pretty(link.dataset.response));
      $("#picking-eos-push-dialog").modal("show");
    });
  }

  pretty(raw: string): string {
    try {
      return JSON.stringify(JSON.parse(raw), null, 2);
    } catch {
      return raw || "";
    }
  }
}

export function LoadPage() {
  InitPageStrict("logs index", () => {
    if (document.getElementById("picking-history")) new PickingHistory();
  });
}
